export enum GlobalCartRoutes {
  BASE = 'cart'
}
